(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3333],{

/***/ 4449:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/protocols/[code]",
      function () {
        return __webpack_require__(63536);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5049:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ TabIconButton; },
/* harmony export */   "Y": function() { return /* binding */ TabButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var polished__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(17573);
/* harmony import */ var src_components_common_Button__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78296);
/* harmony import */ var src_styles_designs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73098);
/* harmony import */ var src_styles_theme__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68251);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87379);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n            font-weight: 700;\n            color: ",
        " !important;\n            border-color: ",
        " !important;\n            b,\n            strong {\n              font-weight: 700;\n            }\n          "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n            font-weight: 300;\n            color: ",
        ";\n            b,\n            strong {\n              font-weight: 300;\n            }\n          "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  && {\n    display: flex;\n    align-items: center;\n\n    min-width: min-content;\n    min-height: 26px;\n\n    font-size: 13px;\n    line-height: 21px;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n    white-space: nowrap;\n\n    transition: all 0.2s ease;\n\n    color: ",
        ";\n    border-bottom: 1rpx solid\n      ",
        ";\n\n    ",
        " {\n      font-size: 14px;\n      padding-bottom: 6px;\n    }\n\n    br {\n      display: none;\n    }\n\n    &:hover,\n    &:focus {\n      color: ",
        ";\n      border-color: currentColor;\n    }\n\n    ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  && {\n    min-width: 24px;\n    justify-content: center;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}





var TabButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__["default"])(src_components_common_Button__WEBPACK_IMPORTED_MODULE_1__/* .CleanButton */ .ux).withConfig({
    displayName: "TabButton",
    componentId: "sc-71a4751e-0"
})(_templateObject2(), (0,src_styles_theme__WEBPACK_IMPORTED_MODULE_3__/* .fromTheme */ .HW)(function(theme) {
    return theme.text.palette.primary;
}), (0,src_styles_theme__WEBPACK_IMPORTED_MODULE_3__/* .fromTheme */ .HW)(function(theme) {
    return (0,polished__WEBPACK_IMPORTED_MODULE_5__/* .transparentize */ .DZ)(0.6, theme.text.palette.primary);
}), src_styles_designs__WEBPACK_IMPORTED_MODULE_2__/* .media.w.greaterThanOrEqual.desktop */ .BC.w.greaterThanOrEqual.desktop, (0,src_styles_theme__WEBPACK_IMPORTED_MODULE_3__/* .fromTheme */ .HW)(function(theme) {
    return theme.text.palette.accent;
}), function(param) {
    var $active = param.$active;
    return $active ? (0,styled_components__WEBPACK_IMPORTED_MODULE_4__.css)(_templateObject(), (0,src_styles_theme__WEBPACK_IMPORTED_MODULE_3__/* .fromTheme */ .HW)(function(theme) {
        return theme.text.palette.accent;
    }), (0,src_styles_theme__WEBPACK_IMPORTED_MODULE_3__/* .fromTheme */ .HW)(function(theme) {
        return theme.text.palette.accent;
    })) : (0,styled_components__WEBPACK_IMPORTED_MODULE_4__.css)(_templateObject1(), (0,src_styles_theme__WEBPACK_IMPORTED_MODULE_3__/* .fromTheme */ .HW)(function(theme) {
        return theme.text.palette.heavy;
    }));
});
var TabIconButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__["default"])(TabButton).withConfig({
    displayName: "TabButton__TabIconButton",
    componentId: "sc-71a4751e-1"
})(_templateObject3());


/***/ }),

/***/ 16001:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ ScrollToSectionOnClick; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var src_providers_LayoutRegisterProvider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63085);
/* harmony import */ var src_components_common_ResponsiveUnit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47631);







var ScrollToSectionOnClick = function(_param) {
    var children = _param.children, id = _param.id, _offset = _param.offset, offset = _offset === void 0 ? 0 : _offset, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "children",
        "id",
        "offset"
    ]);
    var ref;
    var layoutRegisterContext = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(src_providers_LayoutRegisterProvider__WEBPACK_IMPORTED_MODULE_2__/* .LayoutRegisterContext */ .D);
    var scrollToSection = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(px) {
        var section = document === null || document === void 0 ? void 0 : document.querySelector("#".concat(id));
        if (section != null) {
            var ref;
            var _fixed;
            window.scrollTo({
                top: section.getBoundingClientRect().top + window.scrollY - offset * px - ((_fixed = (ref = layoutRegisterContext === null || layoutRegisterContext === void 0 ? void 0 : layoutRegisterContext.ui.height) === null || ref === void 0 ? void 0 : ref.header.fixed) !== null && _fixed !== void 0 ? _fixed : 0) * px,
                behavior: "smooth"
            });
        }
    }, [
        id,
        offset,
        (ref = layoutRegisterContext === null || layoutRegisterContext === void 0 ? void 0 : layoutRegisterContext.ui.height) === null || ref === void 0 ? void 0 : ref.header.fixed
    ]);
    var clickCallback = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(e, px) {
        var _props, ref, ref1;
        (ref = (_props = children.props).onClick) === null || ref === void 0 ? void 0 : ref.call(_props, e);
        (ref1 = props.onClick) === null || ref1 === void 0 ? void 0 : ref1.call(props, e);
        scrollToSection(px);
    }, [
        children.props,
        props,
        scrollToSection
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_common_ResponsiveUnit__WEBPACK_IMPORTED_MODULE_3__/* .ResponsiveUnit */ .D, {
        children: function(px) {
            return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.cloneElement)(children, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, props), {
                onClick: function(e) {
                    return clickCallback(e, px);
                }
            }));
        }
    });
};


/***/ }),

/***/ 25196:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ StickyMenu; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(36305);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(87379);
/* harmony import */ var src_styles_designs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73098);
/* harmony import */ var src_styles_theme__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68251);
/* harmony import */ var polished__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(17573);
/* harmony import */ var vendor_mods_styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10395);
/* harmony import */ var src_hooks_useRectMeasure__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(48101);
/* harmony import */ var src_hooks_useWindowScroll__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(87802);
/* harmony import */ var src_hooks_useMediaQuery__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(10763);
/* harmony import */ var src_components_common_TabsSwiper__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2277);
/* harmony import */ var src_components_common_StickyMenu_StickyMenuContext__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(95175);
/* harmony import */ var src_utils_casePathEmptyString__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(12732);






function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      right: calc(var(--scrollbar-padding) / 2);\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    .sticky-menu__navbar {\n      background: rgba(255, 255, 255, 0.85);\n    }\n    ",
        " {\n      .sticky-menu__navbar {\n        background: ",
        ";\n      }\n      .sticky-menu__button {\n        color: ",
        ";\n        border-color: ",
        ";\n      }\n    }\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    backdrop-filter: blur(0px) !important;\n    .sticky-menu__navbar {\n      background: transparent !important;\n    }\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: ",
        ";\n  top: calc(var(--header-fixed-height));\n\n  ",
        ";\n\n  display: flex;\n  justify-content: center;\n\n  width: 100%;\n  z-index: 10;\n\n  backdrop-filter: blur(8rpx);\n  transform: translate3d(0, 0, 0);\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  padding-top: 8px;\n  padding-bottom: 9px;\n  background: transparent;\n  transition: 0.25s;\n  height: ",
        "px;\n\n  ",
        " {\n    padding-top: 11px;\n    padding-bottom: 13px;\n    height: ",
        "px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: ",
        "px;\n  ",
        " {\n    height: ",
        "px;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}













var height = {
    mobile: 42,
    desktop: 52
};
var Container = styled_components__WEBPACK_IMPORTED_MODULE_11__["default"].div.withConfig({
    displayName: "StickyMenu__Container",
    componentId: "sc-1526bfc7-0"
})(_templateObject3(), function(param) {
    var $fixed = param.$fixed;
    return $fixed ? "fixed" : "sticky";
}, function(param) {
    var $fixed = param.$fixed;
    return $fixed && (0,styled_components__WEBPACK_IMPORTED_MODULE_11__.css)(_templateObject());
}, (0,src_utils_casePathEmptyString__WEBPACK_IMPORTED_MODULE_10__/* .casePathEmptyString */ .Q)("$passedBanner")((0,styled_components__WEBPACK_IMPORTED_MODULE_11__.css)(_templateObject1(), src_styles_designs__WEBPACK_IMPORTED_MODULE_3__/* .media.w.lessThan.desktop */ .BC.w.lessThan.desktop, (0,src_styles_theme__WEBPACK_IMPORTED_MODULE_4__/* .fromTheme */ .HW)(function(theme) {
    return (0,polished__WEBPACK_IMPORTED_MODULE_12__/* .transparentize */ .DZ)(0.15, theme.palette.background);
}), (0,src_styles_theme__WEBPACK_IMPORTED_MODULE_4__/* .fromTheme */ .HW)(function(theme) {
    return theme.text.palette.heavy;
}), (0,src_styles_theme__WEBPACK_IMPORTED_MODULE_4__/* .fromTheme */ .HW)(function(theme) {
    return (0,polished__WEBPACK_IMPORTED_MODULE_12__/* .transparentize */ .DZ)(0.15, theme.text.palette.heavy);
}))), (0,src_utils_casePathEmptyString__WEBPACK_IMPORTED_MODULE_10__/* .casePathEmptyString */ .Q)("$transparent")((0,styled_components__WEBPACK_IMPORTED_MODULE_11__.css)(_templateObject2())));
var Navbar = styled_components__WEBPACK_IMPORTED_MODULE_11__["default"].div.withConfig({
    displayName: "StickyMenu__Navbar",
    componentId: "sc-1526bfc7-1"
})(_templateObject4(), height.mobile, src_styles_designs__WEBPACK_IMPORTED_MODULE_3__/* .media.w.greaterThanOrEqual.desktop */ .BC.w.greaterThanOrEqual.desktop, height.desktop);
var FixedNavbarSpaceReservation = styled_components__WEBPACK_IMPORTED_MODULE_11__["default"].div.withConfig({
    displayName: "StickyMenu__FixedNavbarSpaceReservation",
    componentId: "sc-1526bfc7-2"
})(_templateObject5(), height.mobile, src_styles_designs__WEBPACK_IMPORTED_MODULE_3__/* .media.w.greaterThanOrEqual.desktop */ .BC.w.greaterThanOrEqual.desktop, height.desktop);
var StickyMenu = function(_param) {
    var _tabs = _param.tabs, tabs = _tabs === void 0 ? [] : _tabs, theme = _param.theme, activeTab = _param.activeTab, bannerHeight = _param.bannerHeight, transparentOnTop = _param.transparentOnTop, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_param, [
        "tabs",
        "theme",
        "activeTab",
        "bannerHeight",
        "transparentOnTop"
    ]);
    var y = (0,src_hooks_useWindowScroll__WEBPACK_IMPORTED_MODULE_7__/* .useWindowScroll */ .b)().y;
    var isDesktop = (0,src_hooks_useMediaQuery__WEBPACK_IMPORTED_MODULE_14__/* .useMediaQuery */ .a)(src_styles_designs__WEBPACK_IMPORTED_MODULE_3__/* .media.w.greaterThanOrEqual.desktop */ .BC.w.greaterThanOrEqual.desktop, true);
    var ctx = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(src_components_common_StickyMenu_StickyMenuContext__WEBPACK_IMPORTED_MODULE_9__/* .StickyMenuContext */ .W);
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)((0,src_hooks_useRectMeasure__WEBPACK_IMPORTED_MODULE_6__/* .useRectMeasure */ .R)(isDesktop ? height.desktop : height.mobile), 2), containerRef = ref[0], navHeight = ref[1];
    var passedBanner = bannerHeight == null || y >= bannerHeight - navHeight;
    var isFixed = !bannerHeight ? false : y > navHeight;
    var allTabs = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(tabs).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(ctx.registeredSections));
    if (allTabs.length < 2) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(vendor_mods_styled_components__WEBPACK_IMPORTED_MODULE_5__/* .Theme */ .Q, {
        theme: theme || (passedBanner ? src_styles_theme__WEBPACK_IMPORTED_MODULE_4__/* .defaultTheme */ .uH : src_styles_theme__WEBPACK_IMPORTED_MODULE_4__/* .redTheme */ .MN),
        children: [
            isFixed && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(FixedNavbarSpaceReservation, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Container, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)({}, props), {
                ref: containerRef,
                $fixed: isFixed,
                $passedBanner: passedBanner,
                $transparent: transparentOnTop ? y === 0 : false,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Navbar, {
                    className: "sticky-menu__navbar",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_common_TabsSwiper__WEBPACK_IMPORTED_MODULE_8__/* .TabsSwiper */ .T, {
                        tabs: allTabs,
                        activeTab: activeTab !== null && activeTab !== void 0 ? activeTab : ctx.activeSection,
                        buttonClassName: "sticky-menu__button"
                    })
                })
            }))
        ]
    });
};


/***/ }),

/***/ 2277:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ TabsSwiper; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(87379);
/* harmony import */ var src_components_TrackedLink__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79017);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(72873);
/* harmony import */ var react_t7e__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(17739);
/* harmony import */ var react_t7e__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(react_t7e__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var src_components_common_ScrollToSectionOnClick__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(16001);
/* harmony import */ var src_components_common_Button_TabButton__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5049);
/* harmony import */ var src_components_common_ConstraintContainer__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(71008);
/* harmony import */ var vendor_mods_markdown_components_Markdown__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(15201);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .swiper-slide {\n    min-width: min-content;\n    width: auto;\n  }\n  .swiper-wrapper {\n    gap: 20px;\n    max-width: max-content;\n    margin: 0 auto;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}










var SwiperContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__["default"])(src_components_common_ConstraintContainer__WEBPACK_IMPORTED_MODULE_7__/* .ConstraintContainer */ .a).withConfig({
    displayName: "TabsSwiper__SwiperContainer",
    componentId: "sc-69bd32eb-0"
})(_templateObject());
var TabsSwiperComponent = function(param) {
    var tabs = param.tabs, activeTab = param.activeTab, scrollOffset = param.scrollOffset, buttonClassName = param.buttonClassName, setActiveTab = param.setActiveTab;
    var _ = (0,react_t7e__WEBPACK_IMPORTED_MODULE_10__.useTranslate)()._;
    var swiperRef = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)();
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        if (swiperRef.current) {
            var ref;
            (ref = swiperRef.current) === null || ref === void 0 ? void 0 : ref.slideTo(tabs.findIndex(function(param) {
                var id = param.id;
                return id === activeTab;
            }));
        }
    }, [
        tabs,
        activeTab
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SwiperContainer, {
        as: swiper_react__WEBPACK_IMPORTED_MODULE_4__/* .Swiper */ .t,
        slidesPerView: "auto",
        threshold: 10,
        onSwiper: function(swiper) {
            return swiperRef.current = swiper;
        },
        children: tabs.map(function(tab) {
            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_4__/* .SwiperSlide */ .o, {
                children: tab.link ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_TrackedLink__WEBPACK_IMPORTED_MODULE_2__/* .TrackedLink */ .A, {
                    href: tab.link,
                    passHref: true,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_common_Button_TabButton__WEBPACK_IMPORTED_MODULE_6__/* .TabButton */ .Y, {
                        className: buttonClassName,
                        as: "a",
                        $active: activeTab === tab.id,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(vendor_mods_markdown_components_Markdown__WEBPACK_IMPORTED_MODULE_8__/* .Markdown */ .U, {
                            children: _(tab.label)
                        })
                    })
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_common_ScrollToSectionOnClick__WEBPACK_IMPORTED_MODULE_5__/* .ScrollToSectionOnClick */ .d, {
                    id: tab.id,
                    offset: scrollOffset,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_common_Button_TabButton__WEBPACK_IMPORTED_MODULE_6__/* .TabButton */ .Y, {
                        $active: activeTab === tab.id,
                        className: buttonClassName,
                        onClick: function() {
                            return setActiveTab === null || setActiveTab === void 0 ? void 0 : setActiveTab(tab.id);
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(vendor_mods_markdown_components_Markdown__WEBPACK_IMPORTED_MODULE_8__/* .Markdown */ .U, {
                            children: _(tab.label)
                        })
                    })
                })
            }, tab.id);
        })
    });
};
var TabsSwiper = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_3__.memo)(TabsSwiperComponent);


/***/ }),

/***/ 63536:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _code_; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/models/pim/dictionaries.ts
var dictionaries = __webpack_require__(56987);
// EXTERNAL MODULE: ./src/models/pim/attributes.ts
var pim_attributes = __webpack_require__(74822);
// EXTERNAL MODULE: ./src/modules/products/components/ProductPage/ProductPageLegalMentions.tsx + 2 modules
var ProductPageLegalMentions = __webpack_require__(42768);
// EXTERNAL MODULE: ./src/modules/products/components/ProductPage/ProductPageSctSection/index.tsx + 1 modules
var ProductPageSctSection = __webpack_require__(11287);
// EXTERNAL MODULE: ./src/modules/products/components/ProductPage/ProductPageBenefitsSection.tsx
var ProductPageBenefitsSection = __webpack_require__(35361);
// EXTERNAL MODULE: ./src/modules/products/components/ProductPage/ProductPageResultsSection.tsx
var ProductPageResultsSection = __webpack_require__(74762);
// EXTERNAL MODULE: ./src/modules/products/components/ProductPage/ProductPageSEO.tsx
var ProductPageSEO = __webpack_require__(85170);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./src/hooks/directus/useTranslateItem.ts
var useTranslateItem = __webpack_require__(70057);
// EXTERNAL MODULE: ./src/components/common/ConstraintContainer.tsx
var ConstraintContainer = __webpack_require__(71008);
// EXTERNAL MODULE: ./src/components/common/Heading.tsx
var Heading = __webpack_require__(79557);
// EXTERNAL MODULE: ./src/styles/designs.ts
var designs = __webpack_require__(73098);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 12 modules
var swiper_react = __webpack_require__(72873);
// EXTERNAL MODULE: ./src/components/common/Swipers/ContentSwiper.tsx
var ContentSwiper = __webpack_require__(77314);
// EXTERNAL MODULE: ./src/modules/materials/components/ShowcasePage/common.tsx
var common = __webpack_require__(52178);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./src/modules/products/hooks/useProductAttributes.ts
var useProductAttributes = __webpack_require__(50999);
// EXTERNAL MODULE: ./vendor/mods/markdown/components/Markdown.tsx
var Markdown = __webpack_require__(15201);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/common/PimImage.tsx
var PimImage = __webpack_require__(43573);
// EXTERNAL MODULE: ./src/models/pim/index.ts
var pim = __webpack_require__(82445);
// EXTERNAL MODULE: ./src/services/route.ts + 1 modules
var route = __webpack_require__(38325);
// EXTERNAL MODULE: ./src/components/TrackedLink.tsx
var TrackedLink = __webpack_require__(79017);
// EXTERNAL MODULE: ./src/components/common/Button/index.tsx + 8 modules
var Button = __webpack_require__(78296);
// EXTERNAL MODULE: ./node_modules/react-t7e/lib/index.js
var lib = __webpack_require__(17739);
// EXTERNAL MODULE: ./src/components/common/typography/Text.tsx
var Text = __webpack_require__(51306);
;// CONCATENATED MODULE: ./src/modules/products/components/ProductPage/ProductPageInvolvedProducts/ProductPageInvolvedProductsItem.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 24px;\n  padding: 40px 24px;\n  text-align: center;\n\n  width: 280px;\n\n  background: ",
        ";\n  border: 2px solid transparent;\n  transition: 0.35s;\n\n  &:hover {\n    border-color: ",
        ";\n  }\n\n  ",
        " {\n    width: 337px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 1.5;\n  text-align: center;\n  margin-bottom: 8px;\n  margin-top: auto;\n\n  color: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 220px;\n  height: 220px;\n  object-fit: contain;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-width: 195px !important;\n  margin-top: auto;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}













var Container = styled_components_browser_esm["default"].a.withConfig({
    displayName: "ProductPageInvolvedProductsItem__Container",
    componentId: "sc-b385cc2f-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.palette.background;
}, function(param) {
    var theme = param.theme;
    return theme.buttons.default.primary.hover.accent;
}, designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var Name = styled_components_browser_esm["default"].h5.withConfig({
    displayName: "ProductPageInvolvedProductsItem__Name",
    componentId: "sc-b385cc2f-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.text.palette.primary;
});
var ImageContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductPageInvolvedProductsItem__ImageContainer",
    componentId: "sc-b385cc2f-2"
})(_templateObject2());
var StyledButton = (0,styled_components_browser_esm["default"])(Button/* Button */.zx).withConfig({
    displayName: "ProductPageInvolvedProductsItem__StyledButton",
    componentId: "sc-b385cc2f-3"
})(_templateObject3());
var ProductPageInvolvedProductsItem = function(_item) {
    var _ = (0,lib.useTranslate)()._;
    var item = (0,useTranslateItem/* useTranslateItem */.L)(_item);
    var _description;
    var descriptionToDisplay = (_description = item.description) !== null && _description !== void 0 ? _description : item.description_short;
    var link = (0,react.useMemo)(function() {
        var category = Object.values(pim/* ProductCategoryCode */.qv).find(function(code) {
            return item.code.includes("sct-".concat(code));
        });
        if (category) {
            return "/products?".concat(category);
        }
        return route/* route.products */.BC.products().page(item);
    }, [
        item
    ]);
    if (!link) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TrackedLink/* TrackedLink */.A, {
        href: link,
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageContainer, {
                    children: item.image && /*#__PURE__*/ (0,jsx_runtime.jsx)(PimImage/* PimImage */.o, {
                        src: item.image.id,
                        width: 220,
                        height: 220,
                        objectFit: "contain",
                        sizes: "100vw"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Name, {
                            children: item.name
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Paragraph */.n, {
                            children: descriptionToDisplay && /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                                children: descriptionToDisplay
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
                    children: _("Discover More")
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/components/common/StickyMenu/StickyMenuSection.tsx
var StickyMenuSection = __webpack_require__(226);
;// CONCATENATED MODULE: ./src/modules/products/components/ProductPage/ProductPageInvolvedProducts/index.tsx



function ProductPageInvolvedProducts_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 32px 0;\n  overflow: hidden;\n\n  ",
        " {\n    padding: 56px 0;\n  }\n"
    ]);
    ProductPageInvolvedProducts_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ProductPageInvolvedProducts_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  justify-content: flex-start;\n\n  &&& {\n    ",
        " {\n      top: 50%;\n      transform: translateY(-50%);\n      margin: 0;\n      display: flex !important;\n    }\n  }\n\n  .swiper-wrapper {\n    gap: 20px;\n  }\n\n  .swiper-slide {\n    width: min-content;\n    height: auto;\n    display: flex;\n  }\n"
    ]);
    ProductPageInvolvedProducts_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

















var Section = (0,styled_components_browser_esm["default"])(StickyMenuSection/* StickyMenuSection */.T).withConfig({
    displayName: "ProductPageInvolvedProducts__Section",
    componentId: "sc-14e8575b-0"
})(ProductPageInvolvedProducts_templateObject(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var SwiperContainer = (0,styled_components_browser_esm["default"])(ContentSwiper/* ContentSwiper */.o).withConfig({
    displayName: "ProductPageInvolvedProducts__SwiperContainer",
    componentId: "sc-14e8575b-1"
})(ProductPageInvolvedProducts_templateObject1(), common/* NavigationButton */.W);
var ProductPageInvolvedProducts = function(product) {
    var translateFn = (0,useTranslateItem/* useTranslateItem */.L)();
    var _ = (0,lib.useTranslate)()._;
    var ref = (0,useProductAttributes/* useProductAttributes */.g)(product.attributes), getProductAttribute = ref.getProductAttribute, getMultipleProductAttributes = ref.getMultipleProductAttributes;
    var title = (0,lodash.head)(getProductAttribute(pim_attributes/* ProductAttributeCode.ProductsInvolvedTitle */.c.ProductsInvolvedTitle));
    var items = (0,react.useMemo)(function() {
        return getMultipleProductAttributes(pim_attributes/* ProductAttributeCode.ProductsInvolvedGroup */.c.ProductsInvolvedGroup).map(function(attributes) {
            var ref, ref1, ref2, ref3;
            var ref4;
            var involvedProduct = translateFn((ref4 = (ref = (0,lodash.head)(getProductAttribute(pim_attributes/* ProductAttributeCode.ProductsInvolvedGroupProduct */.c.ProductsInvolvedGroupProduct, attributes))) === null || ref === void 0 ? void 0 : ref.products_id) !== null && ref4 !== void 0 ? ref4 : {});
            var ref5, ref6, ref7, ref8, ref9;
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, involvedProduct), {
                code: (ref5 = getProductAttribute(pim_attributes/* ProductAttributeCode.ProductsInvolvedGroupCode */.c.ProductsInvolvedGroupCode, attributes)) !== null && ref5 !== void 0 ? ref5 : involvedProduct.code,
                name: (ref7 = (ref1 = translateFn((ref6 = (0,lodash.head)(getProductAttribute(pim_attributes/* ProductAttributeCode.ProductsInvolvedGroupName */.c.ProductsInvolvedGroupName, attributes))) !== null && ref6 !== void 0 ? ref6 : {})) === null || ref1 === void 0 ? void 0 : ref1.value) !== null && ref7 !== void 0 ? ref7 : involvedProduct.name,
                image: (ref8 = (ref2 = (0,lodash.head)(getProductAttribute(pim_attributes/* ProductAttributeCode.ProductsInvolvedGroupImage */.c.ProductsInvolvedGroupImage, attributes))) === null || ref2 === void 0 ? void 0 : ref2.directus_files_id) !== null && ref8 !== void 0 ? ref8 : involvedProduct.image,
                description: (ref3 = translateFn((ref9 = (0,lodash.head)(getProductAttribute(pim_attributes/* ProductAttributeCode.ProductsInvolvedGroupText */.c.ProductsInvolvedGroupText, attributes))) !== null && ref9 !== void 0 ? ref9 : {})) === null || ref3 === void 0 ? void 0 : ref3.value
            });
        }).filter(function(p) {
            return !!p.code;
        });
    }, [
        getMultipleProductAttributes,
        getProductAttribute,
        translateFn
    ]);
    if (items.length === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section, {
        id: "involved-products",
        label: _("Protocol products"),
        threshold: {
            desktop: 0.5,
            mobile: 0.8
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConstraintContainer/* ConstraintContainer */.a, {
            children: [
                title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* Heading */.X, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                        children: translateFn(title).value
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SwiperContainer, {
                    children: items.map(function(item, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPageInvolvedProductsItem, (0,_object_spread/* default */.Z)({}, item))
                        }, item.code + index);
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/components/common/StickyMenu/StickyMenuContext.tsx
var StickyMenuContext = __webpack_require__(95175);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./src/components/common/StickyMenu/index.tsx
var StickyMenu = __webpack_require__(25196);
// EXTERNAL MODULE: ./src/hooks/useRectMeasure.ts
var useRectMeasure = __webpack_require__(48101);
// EXTERNAL MODULE: ./vendor/mods/styled-components/index.tsx
var styled_components = __webpack_require__(10395);
// EXTERNAL MODULE: ./src/styles/theme.ts + 3 modules
var theme = __webpack_require__(68251);
// EXTERNAL MODULE: ./src/modules/products/components/ProductLogo.tsx + 3 modules
var ProductLogo = __webpack_require__(1036);
;// CONCATENATED MODULE: ./src/modules/products/components/ProductPage/ProductPageProtocolsBannerSection/index.tsx


function ProductPageProtocolsBannerSection_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  position: absolute;\n\n  &::before {\n    content: '';\n    background-color: currentColor;\n    position: absolute;\n    top: -10px;\n    left: -90px;\n    width: 65px;\n    height: 285px;\n    clip-path: polygon(0 0, 40% 0, 100% 100%, 95% 100%);\n\n    ",
        " {\n      left: auto;\n      right: -90px;\n      clip-path: polygon(60% 0, 100% 0, 5% 100%, 0 100%);\n    }\n  }\n\n  ",
        " {\n    display: none;\n  }\n"
    ]);
    ProductPageProtocolsBannerSection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ProductPageProtocolsBannerSection_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  background: ",
        ";\n\n  ",
        " {\n    min-height: 574px;\n  }\n"
    ]);
    ProductPageProtocolsBannerSection_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ProductPageProtocolsBannerSection_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 64px 0 52px;\n\n  ",
        " {\n    display: flex;\n    justify-content: space-between;\n    gap: 48px;\n    max-width: 1080px;\n\n    padding-left: 60px;\n    ",
        " {\n      padding-right: 60px;\n      padding-left: 0;\n    }\n  }\n"
    ]);
    ProductPageProtocolsBannerSection_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ProductPageProtocolsBannerSection_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  max-width: 360px;\n\n  ",
        " {\n    ",
        "::before {\n      content: none;\n    }\n  }\n"
    ]);
    ProductPageProtocolsBannerSection_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 500;\n  margin: 32px 0 16px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 427px;\n  height: 424px;\n\n  ",
        " {\n    display: none;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: -92px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}















var Needle = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductPageProtocolsBannerSection__Needle",
    componentId: "sc-e2c4895d-0"
})(ProductPageProtocolsBannerSection_templateObject(), function(param) {
    var theme = param.theme;
    return theme.text.palette.white;
}, theme/* dirRTL */.gX, designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop);
var ProductPageProtocolsBannerSection_Container = styled_components_browser_esm["default"].section.withConfig({
    displayName: "ProductPageProtocolsBannerSection__Container",
    componentId: "sc-e2c4895d-1"
})(ProductPageProtocolsBannerSection_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.text.palette.primary;
}, function(param) {
    var theme = param.theme;
    return theme.gradients.primary;
}, designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var ContentContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductPageProtocolsBannerSection__ContentContainer",
    componentId: "sc-e2c4895d-2"
})(ProductPageProtocolsBannerSection_templateObject2(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop, designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop);
var Content = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductPageProtocolsBannerSection__Content",
    componentId: "sc-e2c4895d-3"
})(ProductPageProtocolsBannerSection_templateObject3(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop, Heading/* Heading */.X);
var Highlight = (0,styled_components_browser_esm["default"])(Text/* Paragraph */.n).withConfig({
    displayName: "ProductPageProtocolsBannerSection__Highlight",
    componentId: "sc-e2c4895d-4"
})(_templateObject4());
var ProductPageProtocolsBannerSection_ImageContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductPageProtocolsBannerSection__ImageContainer",
    componentId: "sc-e2c4895d-5"
})(_templateObject5(), designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop);
var ImageInnerContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductPageProtocolsBannerSection__ImageInnerContainer",
    componentId: "sc-e2c4895d-6"
})(_templateObject6());
var ProductPageProtocolsBannerSection = function(_product) {
    var ref = (0,_sliced_to_array/* default */.Z)((0,useRectMeasure/* useRectMeasure */.R)(), 2), bannerRef = ref[0], height = ref[1];
    var product = (0,useTranslateItem/* useTranslateItem */.L)(_product);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_components/* Theme */.Q, {
        theme: product.code === "nrose" ? theme/* nroseTheme */.U0 : theme/* redTheme */.MN,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductPageProtocolsBannerSection_Container, {
            ref: bannerRef,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StickyMenu/* StickyMenu */.a, {
                    bannerHeight: height
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ConstraintContainer/* ConstraintContainer */.a, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentContainer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Needle, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* Heading */.X, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductLogo/* ProductLogo */.q, {
                                            size: "big",
                                            code: product.code
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Paragraph */.n, {
                                        children: product.tagline
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Highlight, {
                                        children: product.function && /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                                            children: product.function
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Paragraph */.n, {
                                        children: product.description_short
                                    })
                                ]
                            }),
                            product.image && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPageProtocolsBannerSection_ImageContainer, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageInnerContainer, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PimImage/* PimImage */.o, {
                                        src: product.image.id,
                                        layout: "fill",
                                        objectFit: "cover",
                                        sizes: "100vw"
                                    })
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/modules/products/components/ProductPage/ProductPageProtocolsSessions/ProductPageProtocolsSessionsItemProduct.tsx

function ProductPageProtocolsSessionsItemProduct_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: 8px;\n  padding: 16px 0;\n  border-bottom: 1rpx solid ",
        ";\n"
    ]);
    ProductPageProtocolsSessionsItemProduct_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ProductPageProtocolsSessionsItemProduct_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 16px;\n  font-weight: 500;\n  margin-bottom: 6px;\n"
    ]);
    ProductPageProtocolsSessionsItemProduct_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ProductPageProtocolsSessionsItemProduct_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 13px;\n"
    ]);
    ProductPageProtocolsSessionsItemProduct_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ProductPageProtocolsSessionsItemProduct_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 64px;\n  height: 64px;\n"
    ]);
    ProductPageProtocolsSessionsItemProduct_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}






var ProductPageProtocolsSessionsItemProduct_Container = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductPageProtocolsSessionsItemProduct__Container",
    componentId: "sc-84de518e-0"
})(ProductPageProtocolsSessionsItemProduct_templateObject(), function(param) {
    var theme = param.theme;
    return theme.skeleton.base;
});
var ProductPageProtocolsSessionsItemProduct_Name = (0,styled_components_browser_esm["default"])(Text/* Paragraph */.n).withConfig({
    displayName: "ProductPageProtocolsSessionsItemProduct__Name",
    componentId: "sc-84de518e-1"
})(ProductPageProtocolsSessionsItemProduct_templateObject1());
var Description = (0,styled_components_browser_esm["default"])(Text/* Paragraph */.n).withConfig({
    displayName: "ProductPageProtocolsSessionsItemProduct__Description",
    componentId: "sc-84de518e-2"
})(ProductPageProtocolsSessionsItemProduct_templateObject2());
var ProductPageProtocolsSessionsItemProduct_ImageContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductPageProtocolsSessionsItemProduct__ImageContainer",
    componentId: "sc-84de518e-3"
})(ProductPageProtocolsSessionsItemProduct_templateObject3());
var ProductPageProtocolsSessionsItemProduct = function(param) {
    var products_id = param.products_id;
    var product = (0,useTranslateItem/* useTranslateItem */.L)(products_id);
    var _tagline;
    var description = (_tagline = product.tagline) !== null && _tagline !== void 0 ? _tagline : product.description_short;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductPageProtocolsSessionsItemProduct_Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPageProtocolsSessionsItemProduct_ImageContainer, {
                children: product.image && /*#__PURE__*/ (0,jsx_runtime.jsx)(PimImage/* PimImage */.o, {
                    src: product.image.id,
                    layout: "fill",
                    objectFit: "contain",
                    sizes: "100vw"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPageProtocolsSessionsItemProduct_Name, {
                        children: product.name
                    }),
                    description && /*#__PURE__*/ (0,jsx_runtime.jsx)(Description, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                            children: description
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/modules/products/components/ProductPage/ProductPageProtocolsSessions/ProductPageProtocolsSessionsItem.tsx


function ProductPageProtocolsSessionsItem_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 18px;\n  font-weight: 700;\n  text-transform: uppercase;\n"
    ]);
    ProductPageProtocolsSessionsItem_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ProductPageProtocolsSessionsItem_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  max-width: 430px;\n  gap: 16px;\n"
    ]);
    ProductPageProtocolsSessionsItem_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ProductPageProtocolsSessionsItem_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 24px;\n\n  font-size: 40px;\n  font-weight: 500;\n  color: ",
        ";\n"
    ]);
    ProductPageProtocolsSessionsItem_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ProductPageProtocolsSessionsItem_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 100%;\n  height: 1rpx;\n  background: ",
        ";\n  &:after,\n  &:before {\n    content: '';\n    position: absolute;\n    right: 0;\n    width: 7rpx;\n    height: 2rpx;\n    background: ",
        ";\n  }\n  &:before {\n    top: -3rpx;\n    transform: rotate(45deg);\n  }\n  &:after {\n    top: 2rpx;\n    transform: rotate(-45deg);\n  }\n"
    ]);
    ProductPageProtocolsSessionsItem_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}






var ProductPageProtocolsSessionsItem_Heading = styled_components_browser_esm["default"].h3.withConfig({
    displayName: "ProductPageProtocolsSessionsItem__Heading",
    componentId: "sc-c1ccaa73-0"
})(ProductPageProtocolsSessionsItem_templateObject());
var ProductPageProtocolsSessionsItem_Container = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductPageProtocolsSessionsItem__Container",
    componentId: "sc-c1ccaa73-1"
})(ProductPageProtocolsSessionsItem_templateObject1());
var IndexContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductPageProtocolsSessionsItem__IndexContainer",
    componentId: "sc-c1ccaa73-2"
})(ProductPageProtocolsSessionsItem_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.text.palette.accent;
});
var IndexLine = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductPageProtocolsSessionsItem__IndexLine",
    componentId: "sc-c1ccaa73-3"
})(ProductPageProtocolsSessionsItem_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.text.palette.accent;
}, function(param) {
    var theme = param.theme;
    return theme.text.palette.accent;
});
var ProductPageProtocolsSessionsItem = function(param) {
    var title = param.title, description = param.description, items = param.items, index = param.index;
    var translateFn = (0,useTranslateItem/* useTranslateItem */.L)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductPageProtocolsSessionsItem_Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(IndexContainer, {
                children: [
                    "0",
                    index,
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IndexLine, {})
                ]
            }),
            title && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPageProtocolsSessionsItem_Heading, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                    children: translateFn(title).value
                })
            }),
            description && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Paragraph */.n, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                    children: translateFn(description).value
                })
            }),
            items === null || items === void 0 ? void 0 : items.map(function(item, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPageProtocolsSessionsItemProduct, (0,_object_spread/* default */.Z)({}, item), index);
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/modules/products/components/ProductPage/ProductPageProtocolsSessions/index.tsx


function ProductPageProtocolsSessions_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 50px 0;\n  background: ",
        ";\n\n  ",
        " {\n    padding: 80px 0;\n  }\n"
    ]);
    ProductPageProtocolsSessions_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ProductPageProtocolsSessions_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & + & {\n    margin-top: 56px;\n  }\n"
    ]);
    ProductPageProtocolsSessions_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ProductPageProtocolsSessions_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 18px;\n  font-weight: 700;\n  color: ",
        ";\n  text-transform: uppercase;\n  margin: 42px 0 28px;\n"
    ]);
    ProductPageProtocolsSessions_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ProductPageProtocolsSessions_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  gap: 40px;\n  margin-top: 24px;\n\n  ",
        " {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 40px 24px;\n  }\n"
    ]);
    ProductPageProtocolsSessions_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}















var ProductPageProtocolsSessions_Section = (0,styled_components_browser_esm["default"])(StickyMenuSection/* StickyMenuSection */.T).withConfig({
    displayName: "ProductPageProtocolsSessions__Section",
    componentId: "sc-8facafb-0"
})(ProductPageProtocolsSessions_templateObject(), function(param) {
    var theme = param.theme;
    return theme.palette.background;
}, designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var SectionContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductPageProtocolsSessions__SectionContainer",
    componentId: "sc-8facafb-1"
})(ProductPageProtocolsSessions_templateObject1());
var SectionHeading = styled_components_browser_esm["default"].h3.withConfig({
    displayName: "ProductPageProtocolsSessions__SectionHeading",
    componentId: "sc-8facafb-2"
})(ProductPageProtocolsSessions_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.text.palette.accent;
});
var StepsContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductPageProtocolsSessions__StepsContainer",
    componentId: "sc-8facafb-3"
})(ProductPageProtocolsSessions_templateObject3(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var ProductPageProtocolsSessions = function(product) {
    var translateFn = (0,useTranslateItem/* useTranslateItem */.L)();
    var _ = (0,lib.useTranslate)()._;
    var ref = (0,useProductAttributes/* useProductAttributes */.g)(product.attributes), getProductAttribute = ref.getProductAttribute, getMultipleProductAttributes = ref.getMultipleProductAttributes;
    var subtitle = (0,lodash.head)(getProductAttribute(pim_attributes/* ProductAttributeCode.ProtocolsSessionsText */.c.ProtocolsSessionsText));
    var ref1;
    var sections = (0,react.useMemo)(function() {
        var ref;
        return (ref1 = (ref = getMultipleProductAttributes(pim_attributes/* ProductAttributeCode.ProtocolsSessionsGroup */.c.ProtocolsSessionsGroup)) === null || ref === void 0 ? void 0 : ref.map(function(attribute) {
            var ref;
            var steps = (ref = getMultipleProductAttributes(pim_attributes/* ProductAttributeCode.ProtocolsSessionsGroupStepGroup */.c.ProtocolsSessionsGroupStepGroup, attribute)) !== null && ref !== void 0 ? ref : [];
            return {
                title: (0,lodash.head)(getProductAttribute(pim_attributes/* ProductAttributeCode.ProtocolsSessionsGroupTitle */.c.ProtocolsSessionsGroupTitle, attribute)),
                steps: steps.map(function(step) {
                    return {
                        title: (0,lodash.head)(getProductAttribute(pim_attributes/* ProductAttributeCode.ProtocolsSessionsGroupStepGroupTitle */.c.ProtocolsSessionsGroupStepGroupTitle, step)),
                        description: (0,lodash.head)(getProductAttribute(pim_attributes/* ProductAttributeCode.ProtocolsSessionsGroupStepGroupText */.c.ProtocolsSessionsGroupStepGroupText, step)),
                        items: getProductAttribute(pim_attributes/* ProductAttributeCode.ProtocolsSessionsGroupStepGroupProduct */.c.ProtocolsSessionsGroupStepGroupProduct, step)
                    };
                })
            };
        }).filter(function(d) {
            return !!d.title;
        })) !== null && ref1 !== void 0 ? ref1 : [];
    }, [
        getProductAttribute,
        getMultipleProductAttributes
    ]);
    if (sections.length === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPageProtocolsSessions_Section, {
        id: "steps",
        label: _("Protocol steps"),
        index: 2,
        threshold: {
            desktop: 0.3,
            mobile: 0.8
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConstraintContainer/* ConstraintContainer */.a, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Heading/* Heading */.X, {
                    children: [
                        translateFn(product).name,
                        " ",
                        _("Protocol"),
                        subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Paragraph */.n, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                                children: translateFn(subtitle).value
                            })
                        })
                    ]
                }),
                sections.map(function(section, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SectionContainer, {
                        children: [
                            section.title && /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionHeading, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                                    children: translateFn(section.title).value
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StepsContainer, {
                                children: section.steps.map(function(item, i) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPageProtocolsSessionsItem, (0,_object_spread/* default */.Z)({
                                        index: i + 1
                                    }, item), i);
                                })
                            })
                        ]
                    }, index);
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/modules/products/templates/ProductPageProtocolsTemplate.tsx













var ProductPageProtocolsTemplate = function(product) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPageSEO/* ProductPageSEO */.x, (0,_object_spread/* default */.Z)({}, product)),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StickyMenuContext/* StickyMenuProvider */.Q, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPageProtocolsBannerSection, (0,_object_spread/* default */.Z)({}, product)),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPageBenefitsSection/* ProductPageBenefitsSection */.s, {
                        product: product,
                        textCode: pim_attributes/* ProductAttributeCode.TreatmentEssentialsText */.c.TreatmentEssentialsText,
                        titleCode: pim_attributes/* ProductAttributeCode.ProtocolDescriptionTitle */.c.ProtocolDescriptionTitle,
                        descriptionCode: pim_attributes/* ProductAttributeCode.ProtocolDescriptionText */.c.ProtocolDescriptionText
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPageResultsSection/* ProductPageResultsSection */.n, {
                        product: product,
                        textCode: pim_attributes/* ProductAttributeCode.KeyBenefitsText */.c.KeyBenefitsText,
                        titleCode: pim_attributes/* ProductAttributeCode.KeyBenefitsTitle */.c.KeyBenefitsTitle,
                        dictionaryTitleCode: dictionaries/* DictionaryTitlesCode.KeyBenefits */.v.KeyBenefits
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPageInvolvedProducts, (0,_object_spread/* default */.Z)({}, product)),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPageProtocolsSessions, (0,_object_spread/* default */.Z)({}, product)),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPageSctSection/* ProductPageSctSection */.Z, (0,_object_spread/* default */.Z)({}, product)),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPageLegalMentions/* ProductPageLegalMentions */.n, (0,_object_spread/* default */.Z)({}, product))
                ]
            }, product.code)
        ]
    });
};

;// CONCATENATED MODULE: ./src/pages/protocols/[code].tsx



var ProtocolPage = function(param) {
    var product = param.product;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPageProtocolsTemplate, (0,_object_spread/* default */.Z)({}, product));
};
var __N_SSP = true;
/* harmony default export */ var _code_ = (ProtocolPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9046,9774,2888,179], function() { return __webpack_exec__(4449); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);